 
import * as React from 'react';
import { Link } from '@gumtree/ui-library';

import { DisclaimerContainer, Title, Content } from './index.style';
import { VIP_SUPPORT } from '../support-links';

const Disclaimer: React.FC = () => (
    <DisclaimerContainer>
        <hr className="" />
        <Title>Disclaimer</Title>
        <Content>
            This advertisement and the information related to it are provided and maintained by the
            advertiser. Gumtree.com is not responsible and can not guarantee the accuracy or
            completeness of this advertisement. Please note that every advertisement for rent or for
            sale should at a minimum, display the energy performance rating of the property. See our{' '}
            <Link
                href={VIP_SUPPORT.FLAT_HOUSING_POLICY}
                openInNewTab
                text="Flats and Housing Posting Rules"
            />{' '}
            for more information.
        </Content>
    </DisclaimerContainer>
);

export default Disclaimer;
